module.exports = __webpack_public_path__ + "static/media/8_The final lesson_IN.d1987ccf.txt";